import React from "react";
import { useMediaQuery } from "react-responsive";
const SectionFour = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className="section-four-checkout">
      <div className="sec-four-container">
        <div className="left-sec-four">
          <h1>Tap into GoKwik's</h1>
          <h1 style={{ color: "#0012B7", fontWeight: 600 }}>
            165M+ Shoppers Network
          </h1>

          <p>
            Access the largest network of online shoppers to boost engagement
            and conversions
          </p>
        </div>

        <div className="right-sec-four">
          {isMobile ? (
            <div className="checkout-net-card-mob">
              <div className="outer-mob">
                <div className="inner-mob woo-net-card1">
                  <img src="/assets/images/checkout-v-one/frame1.png" alt="" />
                  <div>
                    <h1>200+</h1>
                    <p>Signals for risk profiling</p>
                  </div>
                </div>
              </div>
              <div className="outer-mob">
                <div className="inner-mob woo-net-card2">
                  <img src="/assets/images/checkout-v-one/frame2.png" alt="" />
                  <div>
                    <h1>1.5 Bn+</h1>
                    <p>Click stream data points</p>
                  </div>
                </div>
              </div>
              <div className="outer-mob">
                <div className="inner-mob woo-net-card3">
                  <img src="/assets/images/checkout-v-one/frame3.png" alt="" />
                  <div>
                    <h1>500 M+</h1>
                    <p>Delivery status for orders</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <>
              <img src="/assets/images/checkout-v-one/earth.svg" alt="" />
              <img src="/assets/images/checkout-v-one/group-net.png" alt="" />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionFour;
